import { action, autorun, computed, observable } from 'mobx';
import Ig from '~/stores/ig';

class IgStore extends Ig {

  @observable tab = null;
  @observable reveal = false;
  @observable wide = false;

  constructor(store) {
    super(store);
    autorun(() => {
      if (this.game && !this.tabs.length) {
        this.close();
      }
    });
  }

  @action reset() {
    super.reset();
    this.reveal = false;
  }

  @action close() {
    super.close();
    this.tab = null;
    this.wide = false;
  }

  @action setTab(tab) {
    this.tab = tab;
  }

  @action toggleWide = () => {
    this.wide = !this.wide;
  }

  @action setGame(game, tab) {
    if (!((game && game.video_type) || game.stats)) return;
    if (this.game && this.game.id === game.id) {
      if (tab && tab !== this.tab) {
        this.tab = tab;
      }
      return;
    }
    super.setGame(game);
    if (!tab) {
      tab = this.tabs.find(t => t.show) ? this.tabs.find(t => t.show).name : null;
    }
    this.tab = tab;
  }


  @action toggleDetachVideo = () => {
    this.video.detached = !this.video.detached;
  };

  @action toggleVideoList = () => {
    this.video.showList = !this.video.showList;
  };

  @action toggleReveal = () => {
    this.reveal = !this.reveal;
  };

  onLoadVideo({gid, silent, res}) {
    if (res.code === 2 && !silent) {
      this.store.accountStore.toggleLoginForm(true, 'PLEASE_AUTH_TO_VIEW_THE_BROADCAST');
    } else {
      super.onLoadVideo({ gid, silent, res });
    }
  };

  @computed get tabs() {
    const { video_type, stats } = this.game;
    return [
      {
        name: 'video',
        ico: 'f-s-ico-video',
        show: video_type && video_type[0],
      },
      {
        name: 'events',
        ico: 'f-s-ico-text_live',
        show: stats,
      },
      {
        name: 'stats',
        ico: 'f-s-ico-stat',
        show: stats,
      },
    ].filter(t => t.show);
  }
}
export default new IgStore();


// WEBPACK FOOTER //
// ./src/components/ig/store.js